import axios from "@/api/config_php";

//折线图
export const getSurveyLine = param =>
  axios.post(`/amp/api/v1/statistics/getSurvey`, param);

export const getSurveyLine2 = param =>
  axios.post(`/amp/api/v1/statistics/getSurvey2`, param);

//获取开户公司
export const getAccountCompany = param =>
  axios.post(`/amp/api/v1/statistics/getAccountCompany`, param);

//获取开户公司
export const getAccountGroup = param =>
  axios.post(`/amp/api/v1/statistics/getAccountGroup`, param);

//数据分析汇总
export const getTotalAccount = param =>
  axios.post(`/amp/api/v1/statistics/getTotalAccount`, param);

//广告账户列表
export const getAccountList = param =>
  axios.post(`/amp/api/v1/statistics/getAccountList`, param);

//获取开户名称
export const getAccountNames = param =>
  axios.post(`/amp/api/v1/taskcore/getAccountCompany`, param);

//获取开户名称
export const getAccountTop = param =>
  axios.post(`/amp/api/v1/statistics/getAccountTop`, param);